import React, { useState, useEffect } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import './Navbar.css';

const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();

  const appName = process.env.REACT_APP_NAME || 'UltraCoder IDE';
  const githubUrl = process.env.REACT_APP_GITHUB_URL || '#';
  const isHome = location.pathname === '/';

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  // Close mobile menu on route change
  useEffect(() => {
    setMenuOpen(false);
  }, [location.pathname]);

  const scrollTo = (id) => {
    if (!isHome) {
      navigate('/');
      // small delay so the page mounts before scrolling
      setTimeout(() => {
        document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' });
      }, 100);
    } else {
      document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' });
    }
    setMenuOpen(false);
  };

  return (
    <nav className={`navbar ${scrolled ? 'navbar--scrolled' : ''}`}>
      <div className="navbar__container">
        {/* Brand */}
        <Link to="/" className="navbar__brand" style={{ textDecoration: 'none' }}>
          <div className="navbar__logo">
            <span className="navbar__logo-icon">⚡</span>
          </div>
          <span className="navbar__name">{appName}</span>
        </Link>

        {/* Nav links */}
        <ul className={`navbar__links ${menuOpen ? 'navbar__links--open' : ''}`}>
          <li>
            <button onClick={() => scrollTo('features')}>Features</button>
          </li>
          <li>
            <button onClick={() => scrollTo('about')}>About</button>
          </li>
          <li>
            <button onClick={() => scrollTo('tech')}>Tech Stack</button>
          </li>
          <li>
            <Link to="/pricing" className="navbar__page-link">Pricing</Link>
          </li>
          <li>
            <Link to="/blog" className="navbar__page-link">Blog</Link>
          </li>
          <li>
            <Link to="/docs" className="navbar__page-link">Docs</Link>
          </li>
        </ul>

        {/* Actions */}
        <div className="navbar__actions">
          <a
            href={githubUrl}
            target="_blank"
            rel="noreferrer"
            className="navbar__btn navbar__btn--outline"
          >
            GitHub
          </a>
          <Link to="/pricing" className="navbar__btn navbar__btn--primary">
            Get Started
          </Link>
        </div>

        {/* Hamburger */}
        <button
          className={`navbar__hamburger ${menuOpen ? 'navbar__hamburger--open' : ''}`}
          onClick={() => setMenuOpen(!menuOpen)}
          aria-label="Toggle menu"
        >
          <span></span>
          <span></span>
          <span></span>
        </button>
      </div>
    </nav>
  );
};

export default Navbar;